import { Player } from "@lottiefiles/react-lottie-player";
import React from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  return (
    <>
      {/* <Helmet>
        <title>404 - Page Not Found | Katha Realty</title>
        <meta
          name="description"
          content="Oops! The page you are looking for does not exist."
        />
      </Helmet> */}

      <div className="coming-soon-container">
        <Player
          autoplay
          loop
          src="https://assets3.lottiefiles.com/packages/lf20_jcikwtux.json"
          style={{ height: "300px", width: "300px" }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h1>404 - Page Not Found</h1>
          <p>Sorry, we couldn't find the page you're looking for.</p>
        </div>
      </div>
    </>
  );
};

export default NotFound;
